import initialState from '../../utils/constants/initialState';

const HEADER_TOGGLE = 'GLOBAL_UI_HEADER_TOGGLE';
const HEADER_CLOSE = 'GLOBAL_UI_HEADER_CLOSE';

const toggleHeader = () => ({
  type: HEADER_TOGGLE,
});

const closeHeader = () => ({
  type: HEADER_CLOSE,
});

const globalUiInitialState = initialState.globalUi;

const globalUiReducer = (state = globalUiInitialState, action) => {
  const returnState = Object.assign({}, state);

  switch (action.type) {
    case HEADER_TOGGLE:
      returnState.isHeaderOpen = !state.isHeaderOpen;

      return returnState;

    case HEADER_CLOSE:
      returnState.isHeaderOpen = false;

      return returnState;

    default:
      return state;
  }
};

export {
  toggleHeader,
  closeHeader,
  globalUiReducer,
};



// WEBPACK FOOTER //
// ./redux/ducks/globalUi.js